import { Button } from '@predoc/cow';
import { cn } from '@/lib/utils';
import { MedicalRecordType, MedicalRecordsCounts } from './types';
import { RECORD_TYPES } from './constants';

interface MedicalRecordsSidebarProps {
  counts?: MedicalRecordsCounts;
  selectedType: MedicalRecordType;
  onSelectType: (type: MedicalRecordType) => void;
  isLoading?: boolean;
}

export const MedicalRecordsSidebar = ({
  counts,
  selectedType,
  onSelectType,
  isLoading = false,
}: MedicalRecordsSidebarProps) => {
  return (
    <div className="w-56 shrink-0 rounded-lg bg-gray-100 p-3">
      <nav className="space-y-0.5">
        {RECORD_TYPES.map((recordType) => {
          const isSelected = selectedType === recordType.key;
          const count = counts?.[recordType.countKey] ?? 0;

          return (
            <Button
              key={recordType.key}
              variant="ghost"
              onClick={() => onSelectType(recordType.key)}
              className={cn(
                'flex h-auto w-full items-center justify-between rounded-md px-3 py-1.5 text-left text-sm transition-colors',
                isSelected
                  ? 'text-foreground bg-white font-medium hover:bg-white'
                  : 'text-muted-foreground hover:text-foreground hover:bg-white',
              )}
            >
              <span>{recordType.label}</span>
              {isLoading ? (
                <span className="h-4 w-6 animate-pulse rounded bg-gray-200" />
              ) : (
                <span
                  className={cn(
                    'rounded-full bg-gray-200 px-2 py-0.5 text-xs',
                    isSelected ? 'text-foreground' : 'text-muted-foreground',
                  )}
                >
                  {count}
                </span>
              )}
            </Button>
          );
        })}
      </nav>
    </div>
  );
};
